import { TestimonialTable } from "@/components/testimonial/TestimonialTable";

export default function Testimonial() {
    return (
        <div className="flex items-center h-full pt-10 flex-col">
            < TestimonialTable/>
        </div>
    );
}
